import '../upgradeApi.less';

import { Button } from 'antd';

import { ReactComponent as IconClock } from '@/assets/icon/api-management/icon-clock.svg';
import ByModal from '@/components/ByModal';
import { useI18nContext } from '@/i18n/I18n';

const ProcessModal = ({
  visible,
  onConfirm,
}: {
  visible: boolean;
  onConfirm: () => void;
}) => {
  const [$t] = useI18nContext();

  return (
    <ByModal
      visible={visible}
      modalProps={{ centered: true }}
      ByFooter={[
        <div className="upgrade-api__process--footer" key="footer">
          <Button
            onClick={onConfirm}
            key="confirm"
            type="primary"
            className="bybit-btn-primary"
          >
            {$t('Confirm')}
          </Button>
        </div>,
      ]}
      classNames="upgrade-api__process"
      title={null}
      newStyle
    >
      <div className="upgrade-api__process--clock">
        <IconClock />
      </div>
      <h4>{$t('UpgradeToApiProProcess.title')}</h4>
      <p className="upgrade-api__process--desc">
        {$t('UpgradeToApiProProcess.desc')}
      </p>
    </ByModal>
  );
};

export default ProcessModal;
